export default class FundingRequestService {
    constructor() {
        this.primaryInformation = {};
    }


    getPrimaryInformation() {
        return this.primaryInformation;
    }

    setPrimaryInformation(primaryInfo) {
        this.primaryInformation = primaryInfo;
    }

    clearPrimaryInformation() {
        this.primaryInformation = {};
    }
}



// WEBPACK FOOTER //
// ./src/app/common/fundingRequestData/fundingRequest.js